"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ShoppingBagFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ShoppingBagFilled = function ShoppingBagFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C5.76 0 3.945 1.79 3.945 4v1H2.843a1.01 1.01 0 00-1.01.91l-.829 9A1.005 1.005 0 002.014 16h11.972c.596 0 1.064-.505 1.01-1.09l-.83-9a1.008 1.008 0 00-1.01-.91h-1.101V4c0-2.21-1.816-4-4.055-4zm2.027 5V4c0-1.105-.907-2-2.027-2s-2.027.895-2.027 2v1h4.054zm2.028 3c0 .552-.454 1-1.014 1s-1.014-.448-1.014-1 .454-1 1.014-1 1.014.448 1.014 1zM4.959 9c.56 0 1.014-.448 1.014-1s-.454-1-1.014-1-1.014.448-1.014 1 .454 1 1.014 1z",
    fill: "currentColor"
  }));
};

exports.ShoppingBagFilled = ShoppingBagFilled;
var _default = ShoppingBagFilled;
exports.default = _default;